var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{staticClass:"o-tabs",attrs:{"value":_vm.activeTab,"destroy-on-hide":_vm.destroyOnHide,"position":"is-centered","type":"is-toggle"},on:{"input":_vm.selectTab}},_vm._l((_vm.tabItems),function(item){return _c('b-tab-item',{key:item.name,attrs:{"value":item.name,"label":item.label}},[_vm._t(item.name)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }